<template>
<section class="tariff-sec">
    <div class="tariff-sec-container">
        <div class="tariff-sec-header">
                <h1>تعرفه</h1>
                <p>
                    تعرفه‌های آن‌کلیک با توجه به میزان شارژ پنل شما محاسبه می‌شود. بازه های شارژ و تعرفه‌های موردنظر در
                    زیر لیست شده است.
                </p>
        </div>
        <div class="tariff-sec-content">
            <div v-for="item in tariffList" :key="item" class="plan">
                <h3>
                   تبلیغ {{item.t}}
                </h3>
                <ul class="plan-features">
                    <li>
                        <p>از ۱ میلیون تا ۲۰ میلیون تومان</p>
                        <p  v-html="item.featOne" class="plan-price"></p>
                    </li>
                    <div class="plan-divider"></div>
                    <li>
                        <p>از ۲۱ میلیون تا ۵۰ میلیون تومان</p>
                        <p v-html="item.featTow" class="plan-price"></p>
                    </li>
                    <div class="plan-divider"></div>
                    <li>
                        <p>از ۵۱ میلیون تا ۲۰۰ میلیون تومان</p>
                        <p v-html="item.featThree" class="plan-price"></p>
                    </li>
                    <div class="plan-divider"></div>
                    <li>
                        <p>از ۲۰۱ میلیون تا ۵۰۰ میلیون تومان</p>
                        <p v-html="item.featFour" class="plan-price"></p>
                    </li>
                    <div class="plan-divider"></div>
                    <li>
                        <p>از ۵۰۱ میلیون به بالا</p>
                        <p v-html="item.featFive" class="plan-price"></p>
                    </li>
                </ul>
                <a class="tariff-btn btn" :href="registerPath">
                    <span>ثبت تبلیغ {{item.t}}</span>
                </a>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { ref, onMounted, inject } from 'vue';
export default {
    name: 'TariffPage',
    setup() {
        const tariffList = ref([
        {
        t: "ویدیویی",
        featOne: `به ازای هر نمایش <span>30</span> تومان`,
        featTow: `به ازای هر نمایش <span>26</span> تومان`,
        featThree: `به ازای هر نمایش <span>22</span> تومان`,
        featFour: `به ازای هر نمایش <span>17</span> تومان`,
        featFive: `به ازای هر نمایش <span>13</span> تومان`,
        },
        {
        t: "همسان",
        featOne: `به ازای هر کلیک <span>1100</span> تومان`,
        featTow: `به ازای هر کلیک <span>1000</span> تومان`,
        featThree: `به ازای هر کلیک <span>900</span> تومان`,
        featFour: `به ازای هر کلیک <span>800</span> تومان`,
        featFive: `به ازای هر کلیک <span>700</span> تومان`,
        },
        {
        t: "بنری",
        featOne: `به ازای هر کلیک <span>1500</span> تومان`,
        featTow: `به ازای هر کلیک <span>1400</span> تومان`,
        featThree: `به ازای هر کلیک <span>1300</span> تومان`,
        featFour: `به ازای هر کلیک <span>1200</span> تومان`,
        featFive: `به ازای هر کلیک <span>1100</span> تومان`,
        },
        ]);

        const registerPath = inject('registerPath');
        const updateMetaTag = inject('updateMetaTag');
        const updateOGTag = inject('updateOGTag');
        const updateCanonicalLink = inject('updateCanonicalLink');

        onMounted (() => {
            updateMetaTag('title', ' تعرفه تبلیغات آنلاین (ویدیویی، بنری و همسان) | آن کلیک');
            updateMetaTag('description', 'مشاهده قیمت ها و تعرفه های تبلیغات آنلاین در آن کلیک. انتخاب پلن مناسب با بودجه مناسب و با بازدهی بالا.');
            updateOGTag('title', ' تعرفه تبلیغات آنلاین (ویدیویی، بنری و همسان) | آن کلیک');
            updateOGTag('description', 'مشاهده قیمت ها و تعرفه های تبلیغات آنلاین در آن کلیک. انتخاب پلن مناسب با بودجه مناسب و با بازدهی بالا.');
            updateOGTag('url', 'https://onclick.ir/tariff');
            updateOGTag('type', 'website');
            updateOGTag('image', require('@/assets/images/onclick.png'));
            updateCanonicalLink('https://onclick.ir/tariff');
        });

        return {
            tariffList,
            registerPath,
        }
    }
}
</script>

<style>
.tariff-sec-container {
    padding: 60px 17px 260px;
    max-width: 1140px;
    margin-inline: auto;
}

.tariff-sec-header {
    margin-bottom: 40px;
}

.tariff-sec-header,
.plan {
    flex-direction: column;
}

.tariff-sec-header,
.tariff-sec-content,
.plan {
    display: flex;
     align-items: center;
}

.tariff-sec-header h1 {
    font-family: IRANYekan-Bold;
    line-height: 42px;
    margin-bottom: 10px;
}

.tariff-sec-header h1,
.plan-price span {
    font-size: 30px;
}

.tariff-sec-header h1,
.tariff-sec-header p,
.plan h3,
.plan-features li p {
    text-align: center;
}

.tariff-sec-header p {
    line-height: 28px;
}

.tariff-sec-content {
    justify-content: space-between;
    gap: 30px;
}

.plan {
    background-color: #fff;
    border-radius: 21px;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: 0.5s;
}

.plan:hover {
    transform: scale(1.1);
}

.plan h3 {
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
    font-size: 20px;
    font-weight: unset;
}

.plan h3,
.tariff-btn {
    background-color: var(--main-pink);
    color: #fff;
}

.plan-features {
    padding: 20px 30px 30px;
}

.plan-features li {
    padding: 15px 10px;
}

.plan-features li p:first-of-type {
    margin-bottom: 15px;
}

.plan-price {
    font-size: 16px;
}

.plan-price span {
    color: var(--main-pink) !important;
}

.plan-divider {
    width: 100%;
    height: 1px;
    background-color: #e1e1e1;
}

.tariff-btn {
    position: absolute;
    bottom: -20px;
    box-shadow: 0px 0px 10px var(--shadow-pink);
}

@media screen and (max-width: 1100px) {
    .tariff-sec-container {
        max-width: 1000px;
    }

    .plan-features {
        padding-inline: 20px;
    }
}

@media screen and (max-width: 992px) {
    .tariff-sec-container {
        max-width: 700px;
        padding-block: 30px 200px;
    }

    .tariff-sec-header h1,
    .plan-price span {
        font-size: 26px;
    }

    .tariff-sec-header p {
        font-size: 16px;
    }

    .tariff-sec-content {
        flex-direction: column;
        gap: 44px;
    }

    .plan {
        width: 100%;
    }

    .plan:hover {
        transform: none;
    }

    .plan-features li p:first-of-type {
        font-size: 16px;
    }

    .plan-price {
        font-size: 14px;
    }
}
</style>
